import { memo, useCallback, useEffect, useState } from "react";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import { useTranslation } from "react-i18next";
import { useFetch } from "@4uhub/lib4uhub";
import {
  getNonLaboratorialExamsPdfSerialListAsTemporary,
  getNonLaboratorialExamsPdfSerialList,
  getNonLaboratorialExamsPdfSerialTasy,
  getNonLaboratorialExamsPdfSerial,
} from "../../../../services/nonLaboratorialExams.service";
import { tokenTemporaryService } from "../../../../services/tokenTemorary.service";
import { useExtensionConfigs } from "../../../../hooks/useExtensionConfigs";
import { Extension } from "../../../../models/intalled-extensions";
import { ActionButton } from "../../Reports/ReportsModal/FileItem/Actions/ActionButton/ActionButton";

type Props = { identifier: number };

const translationPath = "components.reportsModal.actions.";

export const ViewReportsPdfSerialTable = memo(({ identifier }: Props) => {
  const { t } = useTranslation();

  const [cdnUrl, setCdnUrl] = useState<string | null>(null);
  const { fetchExtensionConfig } = useExtensionConfigs();

  const isTemporaryAccess = !!tokenTemporaryService.getTemporaryAccessToken();

  const { sendRequest: fetchOrigins, loading: originsLoading } = useFetch(
    isTemporaryAccess
      ? getNonLaboratorialExamsPdfSerialListAsTemporary
      : getNonLaboratorialExamsPdfSerialList,
  );
  const { sendRequest: fetchNonLabFile, loading: nonLabLoading } = useFetch(
    isTemporaryAccess
      ? getNonLaboratorialExamsPdfSerialTasy
      : getNonLaboratorialExamsPdfSerial,
  );

  const isLoading = originsLoading || nonLabLoading;

  const fetchExtensions = useCallback(async () => {
    const configCdnUrl = await fetchExtensionConfig(Extension.EXAMS, "CDNURL");
    if (!configCdnUrl || configCdnUrl.value === ".") {
      setCdnUrl(null);
    } else {
      setCdnUrl(configCdnUrl.value);
    }
  }, [fetchExtensionConfig]);

  useEffect(() => {
    fetchExtensions();
  }, [fetchExtensions]);

  const openInNewTabHandler = useCallback(async () => {
    const { data: origins, success } = await fetchOrigins(identifier);
    if (!success || !origins || origins.length === 0) return;

    if (cdnUrl) {
      window.open(cdnUrl, "_blank");
      return;
    }

    const { data, success: okNonLab } = await fetchNonLabFile(
      origins[0].identifier,
    );
    if (!okNonLab || !data) return;

    try {
      const byteArray =
        data instanceof ArrayBuffer
          ? new Uint8Array(data)
          : new Uint8Array(data);

      const blob = new Blob([byteArray], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);
      const newTab = window.open();
      if (newTab) newTab.location.href = blobUrl;
    } catch (e) {
      console.error("[PDF] Erro ao abrir arquivo:", e);
    }
  }, [identifier, cdnUrl, fetchOrigins, fetchNonLabFile]);

  return (
    <ActionButton
      icon={OpenInNewRoundedIcon}
      tooltip={t(`${translationPath}open`)}
      disabled={isLoading}
      onClick={openInNewTabHandler}
      loading={isLoading}
    />
  );
});